<template>
  <div>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
          <Transition class="transition thing">
            <video-background 
              playbackRate=0.2
              :src="src"
              :poster="poster"
        
              overlay="linear-gradient(to bottom, #003, transparent)" 
              :class="`thing playercss`"
              :style="`height: 556px;`" v-show="pvisvideo === true">
            </video-background>
          </Transition>
          <div id="panorama" class="thing" v-show="pvisvideo === false && pictureimage === false">
          </div>
          <div v-show="pictureimage === true">
            <img :src="poster" style="margin-bottom: 200px; width: 100%;">
          </div>
        </div>
        
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext"></h1>
        </div>
      </main>
    </section>



    <StockCards :getstocks="getstocks" stocktheme="stockcss"/>

    <StockCards :getstocks="getstocks" stocktheme="stockcss" />

    
<ContainerFluidex :contfluiddataex="contfluiddataex" contfluidatatheme="contfluiddatacss" />

<ContSection :contdata="contdata" contdatatheme="contdatacss"/>
 
<ContainerFluid :contfluiddata="contfluiddata" contfluidatatheme="contfluiddatacss" />


  <section class="divbottom">
      <hr class="hrclass"/>
      <span v-html="opovbottomtext" class="hrspantext">
      </span>
  </section>
  
  
  <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import StockCards from '@/components/StockCards.vue';
import ContainerFluid from '@/components/ContainerFluid.vue';
import ContainerFluidex from '@/components/ContainerFluidex.vue';
import ContSection from '@/components/ContSection.vue';
require('@/globalDeclare.js');
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
// require('@/setup.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, StockCards, ContainerFluid, ContSection, ContainerFluidex
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  cvdesc: '',
  
  //operations variables
  opsoverviewinfo: [],
  opsovprodimage: '',
  opsovreserveimage: '',
  opsovotherportimg: '',
  opovprodtxt: '',
  opovprodlinktxt: '',
  opovreservetext: '',
  opovreservelinktxt: '',
  opovotherporttext: '',
  opovotherportlinktxt: '',
  opovbottomtext: '',

  cvlink: '',
  pictureimage: '',
  contfluiddata: [],
  contfluiddataex: [],

  contfluidatatheme: [],
  contdata: [],


  myPicUrl: '',
  getstocks: [],
  }
},
mounted() {
  let showImage = Boolean
  showImage = false
  this.myPicUrl = myUrlPath

axios.get('allpagespv/opsoverview').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
      
   //------------Operations Stock Prices---------------
   axios.get('stockprices/opsoverview').then(
      response => {
          this.getstocks = response.data
    })
    .catch((error) => {
        console.log(error)
      })

  //------------Container Fluid Section---------------
  axios.get('getcontainerfluiddata/investoverview').then(
    response => {
        this.contfluiddataex = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Container Fluid Section---------------
  axios.get('getcontainerfluiddata/opsoverview').then(
    response => {
        this.contfluiddata = response.data
  })
  .catch((error) => {
      console.log(error)
    })
//------------Container Section---------------
axios.get('getcontainerdata/opsoverview').then(
  response => {
      this.contdata = response.data
})
.catch((error) => {
    console.log(error)
  })
    //------------Aboutpage contactinfo ---------------
    axios.get('getopsoverviewinfo/').then(
      response => {
          this.opsoverviewinfo = response.data
          this.opsovprodimage = response.data[0]['opsovprodimage']
          this.opsovreserveimage = response.data[0]['opsovreserveimage']
          this.opsovotherportimg = response.data[0]['opsovotherportimg']
          this.opovprodtxt = response.data[0]['opovprodtxt']
          this.opovprodlinktxt = response.data[0]['opovprodlinktxt']
          this.opovreservetext = response.data[0]['opovreservetext']
          this.opovreservelinktxt = response.data[0]['opovreservelinktxt']
          this.opovotherporttext = response.data[0]['opovotherporttext']
          this.opovotherportlinktxt = response.data[0]['opovotherportlinktxt']
          this.opovbottomtext = response.data[0]['opovbottomtext']
    })
    .catch((error) => {
        console.log(error)
      })
      
}
}
</script>

<style lang="scss" scoped>

@import "@/assets/scss/vendors/bootstrap-vue/_custom.scss";
.sectionimage {
  width: 100%;
  margin: 0 auto;
}

.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.txtdata {
  text-align: left;
  background-color: #003;;
  margin-left: 0px;
  opacity: 0.7;
 }

.sectioncontrol {
   height: 100%;
   margin-top: 50px;
   margin-bottom: 40px;
}



/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .txtdata {
    width: 340px;
    margin-top: -370px;
    margin-bottom: 80px;
   }
   .divbottom {
    padding: 60px;
  }

  .pantopsection {
    margin-top: -220px;
  }

 .boxdata{
  position: relative;
  width: 100%;
  height: 320px;
  margin-top: 20px;
  margin-left: 0px;
  border: solid orange thick;
  z-index: 1;
}

  .stockcss {
    width: 100%;
    margin-left: 0px;
    padding: 20px;
  }
}

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .txtdata {
    width: 400px;
    margin-top: -316px;
   }

  .bottompagemsg{
    margin-bottom: 150px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -220px;
  }
  .stockcss {
    width: 100%;
    margin-left: 0px;
    padding: 20px;
  }
  .divbottom {
    padding: 60px;
    text-align: justify;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .bottompagemsg{
    margin-bottom: -200px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -290px;
  }
  .stockcss {
    margin-top: 100px;
  }
  .stockcss1 {
    margin-top: 340px;
  }
  .divbottom {
    padding: 60px;
    text-align: justify;
  }
 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .txtdata {
    width: 500px;
    margin-top: -316px;
    margin-bottom: 100px;
   }
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .panimagesize {
    margin-top: 130px;
  }
  .bottompagemsg{
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -290px;
  }
  .stockcss {
    margin-top: 100px;
  }
  .stockcss1 {
    margin-top: 340px;
  }
  .divbottom {
    padding: 60px;
    text-align: justify;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .txtdata {
    width: 500px;
    margin-top: -56px;
   }
  .pantopsection {
    margin-top: -290px;
  }

  .panimagesize {
    margin-top: 130px;
  }

  .pantopsection {
    margin-top: -290px;
  }
  .stockcss {
    margin-top: 100px;
  }
  .stockcss1 {
    margin-top: 340px;
  }

  .divbottom {
    padding: 60px;
    text-align: justify;
  }
  


 } 


 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1400px) {

  .stockcss {
    width: 100%;
    margin-left: 0px;
    padding: 20px;
    margin-bottom: -120px;
    padding-left: 200px;
    padding-right: 200px;
  }

  .txtdata {
    width: 500px;
    margin-bottom: 10px;
   }
.contfluiddatacss {
  margin-top: 180px;
}
.contdatacss {
  padding-top: 100px;
}
.divbottom {
  padding: 200px;
  text-align: justify;
}
}

  /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {
   .stockcss {
    width: 100%;
    margin-left: 0px;
    padding: 20px;
    margin-bottom: -120px;
    padding-left: 350px;
    padding-right: 350px;
  }

  .txtdata {
    width: 500px;
    margin-bottom: 10px;
   }
}

 

</style>

